// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FO7ui","footer":"styles_footer__yb1B5"};